import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import { IconEye, IconUpLoad } from "../../../../assets/icon";
import moment from "moment";
import { groupNotificationSelector } from "../../../../services/selector/index.";
import { checkNumber, validateUrl } from "../../../../utils/functionCommon";
import BaseButton from "../../Button/BaseButton";
import {
  createGroupNotify,
  setOpenModalPostGroupNotification,
} from "../../../../services/slice/GroupNotificationSlice";
import TabAddGroupNotification from "../../Tabs/TabAddGroupNotification";
import ModalPreviewPostGroupNotify from "../other/ModalPreviewPostGroupNotify";

const ModalAddGroupNotification = ({ title }) => {
  const [datapost, setDataPost] = useState({
    title: "",
    descriptions: "",
    content: "",
    numberCustomer: 0,
    typePreferential: 0,
    typePost: 0,
    timeStart: "",
    timeEnd: "",
    attractGroup: "",
    displayRange: 0,
    redirectUrl: "",
  });
  const groupNotificationState = useSelector(groupNotificationSelector);
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const handleSave = () => {
    const firstTime = new Date(datapost.timeStart).getTime();
    const secondTime = new Date(datapost.timeEnd).getTime();

    const isCommonInvalid =
      !datapost.title || !datapost.timeStart || !datapost.timeEnd;

    const isType1Invalid =
      datapost.typePost === 1 &&
      (isCommonInvalid || !datapost.redirectUrl || !image);

    const isType0Invalid =
      datapost.typePost === 0 &&
      (isCommonInvalid ||
        !datapost.content ||
        datapost.content === "<p><br></p>");

    if (isType1Invalid || isType0Invalid) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }

    if (datapost.typePost === 1 && !validateUrl(datapost.redirectUrl)) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }
    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }
    // if (image && !allowedFormats.includes(image.type)) {
    //   setError({
    //     isError: true,
    //     msg: "File có định dạng .jpeg, .png, .gif",
    //   });
    //   return;
    // }
    if (secondTime - firstTime <= 0) {
      setError({
        isError: true,
        msg: "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc",
      });
      return;
    }
    if (datapost.displayRange === 1 && !datapost.attractGroup.length) {
      setError({
        isError: true,
        msg: "Nhóm khách hàng nhận ưu đãi không xác định",
      });
      return;
    }
    if (
      datapost.displayRange === 1 &&
      datapost.numberCustomer &&
      (!checkNumber(datapost.numberCustomer) || datapost.numberCustomer < 0)
    ) {
      setError({
        isError: true,
        msg: "Bạn nhập sai định dạng. Vui lòng nhập lại",
      });
      return;
    }

    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();

    const announcementDto = {
      title: datapost.title,
      startTime: moment(datapost.timeStart).format("YYYY-MM-DDTHH:mm:ssZ"),
      endTime: moment(datapost.timeEnd).format("YYYY-MM-DDTHH:mm:ssZ"),
      scope: datapost.typePreferential,
      type: datapost.typePost,
      customerType: datapost.displayRange,
      attractGroupIds: datapost.attractGroup || [],
      redirectUrl: datapost.redirectUrl.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      ),
      content: datapost.content.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      ),
    };
    // Gửi object JSON dưới dạng string
    formPost.append(
      "announcement",
      new Blob([JSON.stringify(announcementDto)], { type: "application/json" })
    );
    // Gửi file hình ảnh
    formPost.append("file", datapost.firstImage);
    dispatch(createGroupNotify(formPost));
  };
  const handCancel = () => {
    dispatch(setOpenModalPostGroupNotification(false));
  };

  const handleChangeTab = (key) => {
    setError({
      isError: false,
      msg: "",
    });
    if (key === "content") {
      setDataPost({
        ...datapost,
        content: "",
        typePost: 0,
      });
    } else
      setDataPost({
        ...datapost,
        content: "",
        typePost: 1,
      });
  };
  const handleClickPreview = () => {
    const isCommonInvalid = !datapost.title;

    const isType1Invalid =
      datapost.typePost === 1 && (isCommonInvalid || !datapost.redirectUrl);
    const isType0Invalid =
      datapost.typePost === 0 &&
      (isCommonInvalid ||
        !datapost.content ||
        datapost.content === "<p><br></p>");

    if (isType1Invalid || isType0Invalid) {
      return;
    } else {
      setOpenPreview(true);
    }
  };
  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={groupNotificationState.isOpenModalPostGroupNotification}
        // onOk={() => setOpen(false)}
        onCancel={handCancel}
        footer={[
          <BaseButton
            content={"Xem trước"}
            width={140}
            typeBtn="btnOrange"
            icon={<IconEye fill="white" />}
            handleClick={handleClickPreview}
          />,
          <BaseButton
            content={"Đăng bài viết"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        {openPreview && (
          <ModalPreviewPostGroupNotify
            open={openPreview}
            setOpen={setOpenPreview}
            data={datapost}
          />
        )}
        <Tabs
          onChange={handleChangeTab}
          defaultActiveKey="content"
          items={[
            {
              label: t("Văn bản"),
              key: "content",
              children: (
                <TabAddGroupNotification
                  addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },

            {
              label: t("Hình ảnh"),
              key: "link",
              children: (
                <TabAddGroupNotification
                  addPost={true}
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default ModalAddGroupNotification;
